'use client';

import StepTransition from '@repo/common/components/StepTransition';

const StepsTemplate = ({ children }: { children: React.ReactNode }) => (
  <StepTransition className='flex flex-col grow self-stretch'>
    {children}
  </StepTransition>
);

export default StepsTemplate;
